import { ViewIds } from '@ardoq/api-types';
import { NotificationData, PerspectiveGroupingRule } from '@ardoq/perspectives';
import { isViewWithoutFullyGroupingSupport } from 'views/environmentals/getViewpointModeSupportedViews';
import { getRestrictedGroupingWarningMessage } from 'getRestrictedGroupingWarningMessage';

const getIsWarningMessage = (groupingRules: PerspectiveGroupingRule[]) =>
  groupingRules.length > 0;

export const getRestrictedGroupFormattingWarningProps = (
  viewId: ViewIds,
  groupingRules: PerspectiveGroupingRule[]
): NotificationData | undefined => {
  const isGroupingRuleRestricted = isViewWithoutFullyGroupingSupport(viewId);
  if (!isGroupingRuleRestricted) {
    return;
  }

  const message = getRestrictedGroupingWarningMessage(
    false, // Assuming this is not a view selector warning
    viewId
  );

  const isWarningMessage = message ? getIsWarningMessage(groupingRules) : false;

  return message
    ? {
        message,
        type: isWarningMessage ? 'warning' : 'info',
      }
    : undefined;
};

export const isCreatingGroupingRuleDisabled = (viewId: ViewIds) =>
  isViewWithoutFullyGroupingSupport(viewId);

export const createGetGroupDisabledProps = (viewId: ViewIds) => () => ({
  isDisabled: isViewWithoutFullyGroupingSupport(viewId),
});
